jQuery(document).ready(function ($) {
  $(".cstm-card-slider").slick({
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev"><svg width="40" height="40" viewBox="0 0 72 73" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="35.7484" cy="35.7484" r="34.4984" transform="matrix(-1 0 0 1 72.0017 0.757263)" stroke="darkgray" stroke-width="2.5"/><path d="M43.2474 26.8965L28.4031 36.5057L43.2474 46.1149L43.2474 26.8965Z" stroke="darkgray" stroke-width="2.5"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg width="40" height="40" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="38.0049" cy="37.9608" r="36.25" stroke="darkgray" stroke-width="2.5"/><path d="M30.6069 27.7682L46.3526 37.9608L30.6069 48.1535L30.6069 27.7682Z" stroke="darkgray" stroke-width="2.5"/></svg></button>',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".new-recommend-slider").slick({
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev"><svg width="40" height="40" viewBox="0 0 72 73" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="35.7484" cy="35.7484" r="34.4984" transform="matrix(-1 0 0 1 72.0017 0.757263)" stroke="darkgray" stroke-width="2.5"/><path d="M43.2474 26.8965L28.4031 36.5057L43.2474 46.1149L43.2474 26.8965Z" stroke="darkgray" stroke-width="2.5"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg width="40" height="40" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="38.0049" cy="37.9608" r="36.25" stroke="darkgray" stroke-width="2.5"/><path d="M30.6069 27.7682L46.3526 37.9608L30.6069 48.1535L30.6069 27.7682Z" stroke="darkgray" stroke-width="2.5"/></svg></button>',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  
});
